//External libs
import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Subscription } from 'rxjs';

//Local libs
import Service from 'src/app/common/service';
import SensorModel from './sensor.model';

@Injectable({
  providedIn: 'root'
})
export class SensorService extends Service<SensorModel> {

  public ongoingRequests: Subscription[] = [];

  constructor(public httpClient: HttpClient) {
    super(httpClient, '/aqu/sensor/');
  }

  public getAllTSensors() {
    return new Promise<Array<SensorModel>>((resolve, reject) => {
      const request = this.httpClient.get<Array<SensorModel>>(`${this.baseUrl}${this.serviceUrl}?pageSize=2000&order=new`, this.httpOptions).subscribe(response => {
        resolve(response);
      }, (error: HttpErrorResponse) => {
        reject(error);
      });
      this.ongoingRequests.push(request);
    });
  }

  //To Cancel the onGoing Http Requests
  public cancelOnGoingHttpRequests(): void {
    this.ongoingRequests.forEach((request) => {
      if (request && typeof request.unsubscribe === 'function') {
        request.unsubscribe();
      }
    });
    this.ongoingRequests = [];
  }
}
